import { store } from '@src/store'
import Search from '../icons/search'
import { AppTypes } from '@src/reducers/app.reducer'

// TODO: Refactor other AppTopbuttons to use this component
const SearchButton = () => {
  const toggleSearch = () => store.dispatch({ type: AppTypes.TOGGLE_SEARCH })

  return (
    <div
      className="bg-chineseBlack flex items-center justify-center w-40 h-40 rounded-7 cursor-pointer"
      onClick={toggleSearch}
    >
      <Search className="text-darkGrey w-18 h-18 md:w-20 md:h-20 hover:text-eucalyptus" />
    </div>
  )
}

export default SearchButton
